import { Stack, Typography } from '@mui/material';
import type { FC } from 'react';
import { useFormContext } from 'react-hook-form';
import { useFetchSlackSettings } from '../hooks/useFetchSlackSettings';
import type {
  SlackConfigurationControl,
  SlackConfigurationFormValues,
} from '../SlackConfigurationFormSchema';
import { useEffectOnce } from '../../../../../../../hooks/use-effect-once';
import { ConfigurationsContainer } from '../../../containers/ConfigurationsContainer';
import { ChannelConfigurationSection } from './ChannelConfigurationSection';

type SlackConfigurationFormProps = {
  control: SlackConfigurationControl;
};

export const SlackConfigurationForm: FC<SlackConfigurationFormProps> = ({ control }) => {
  const { configuration } = useFetchSlackSettings();
  const { reset } = useFormContext<SlackConfigurationFormValues>();

  useEffectOnce(() => {
    reset(configuration);
  });

  return (
    <Stack direction="column" sx={{
      gap: 3
    }}>
      <Typography variant="h5">Slack Configuration</Typography>
      <ConfigurationsContainer>
        <ChannelConfigurationSection control={control} defaultValues={configuration} />
      </ConfigurationsContainer>
    </Stack>
  );
}; 